var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M1.51 15.187a1.714 1.714 0 0 0 1.716 1.508h11.768l-2.117 2.076a1.723 1.723 0 0 0 0 2.47c.611.6 1.57.68 2.273.201l.193-.153 4.698-4.603a2.35 2.35 0 0 0 0-3.368l-4.645-4.554c-.611-.6-1.57-.68-2.273-.201l-.193.153-.149.162c-.596.724-.55 1.723.096 2.356l2.117 2.078-11.768-.002c-.953 0-1.726.758-1.726 1.692z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.005 28.5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h9.5v-21h-9.5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h11.5a1 1 0 0 1 1 1v25a1 1 0 0 1-.883.993l-.117.007z"
}))));
export default SvgIconLogin;